// Story 7.1 — post-register "check your inbox" landing surface. Reached
// from CreateAccountForm on 201 success. Also the destination for a
// login attempt that hits EMAIL_NOT_VERIFIED.
//
// If the caller arrives on this page but is ALREADY signed in with a
// verified session, auto-bounce to /feed — they don't belong
// here. useAccountMe returning 200 implies the account is verified,
// since the backend gates login on email_verified.

// LEGAL CHROME: this page carries <SiteFooter>. It is the last step of the
// registration funnel that a signed-out visitor sits on (and can sit on for
// a long time — they leave to open their mail client and come back), and
// the footer's mailto is the trader contact point they need if the mail
// never arrives. It is a calm centred card with no motion budget, so
// chrome costs it nothing.

import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { SiteFooter } from "@greenhold/components";

import { useAccountMe } from "../features/admin/useAccountMe";

export function VerifyEmailPendingPage() {
  const navigate = useNavigate();
  const session = useAccountMe();

  useEffect(() => {
    if (session.data?.data.user_id) {
      navigate("/feed", { replace: true });
    }
  }, [session.data, navigate]);

  if (session.data?.data.user_id) {
    return <Navigate to="/feed" replace />;
  }

  return (
    <div className="min-h-screen bg-brand-forest-900 text-brand-paper-100 flex flex-col">
      <main className="flex flex-1 items-center justify-center px-6 py-12">
        <div className="w-full max-w-md rounded border border-brand-gold-500/40 bg-brand-forest-800 p-8 flex flex-col gap-4">
          <h1 className="font-heading text-2xl m-0 text-brand-gold-300">
            Check your inbox.
          </h1>
          <p className="font-body text-brand-paper-100/80 m-0 leading-relaxed">
            We&apos;ve sent a verification link to your email. Click it to
            activate your account.
          </p>
          <p className="font-body text-sm text-brand-paper-100/60 m-0">
            Nothing arrived after a minute? Check spam.
            {/* Story 7.1b — resend endpoint exists at POST
                /api/v1/auth/resend-verification but v1 ships without a
                resend CTA to keep the pending page copy calm. */}
          </p>
        </div>
      </main>
      <SiteFooter className="mt-0" />
    </div>
  );
}
